import { render, staticRenderFns } from "./InvoicesEmployers.vue?vue&type=template&id=1a47cfea&"
import script from "./InvoicesEmployers.vue?vue&type=script&lang=js&"
export * from "./InvoicesEmployers.vue?vue&type=script&lang=js&"
import style0 from "./InvoicesEmployers.vue?vue&type=style&index=0&id=1a47cfea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports